'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabModalBodyScrollLock } from './PerformanceLabModalBodyScrollLock';
import styles from './PerformanceLabIndiaPurchaseModal.module.css';

type PerformanceLabIndiaPurchaseModalProps = {
  onContinue: () => void;
};

export const PerformanceLabIndiaPurchaseModal: React.FC<
  PerformanceLabIndiaPurchaseModalProps
> = ({ onContinue }) => {
  const t = useTranslations('performance-lab');

  return (
    <PerformanceLabModalBodyScrollLock>
      <div
        className={styles.modalRoot}
        role="dialog"
        aria-modal="true"
        aria-labelledby="pl-india-purchase-title"
      >
        <div className={styles.copyBlock}>
          <h2 className={styles.title} id="pl-india-purchase-title">
            {t('indiaPurchaseModal.title')}
          </h2>
          <div className={styles.body}>
            <p className={styles.description}>
              {t('indiaPurchaseModal.descriptionLine1')}
            </p>
            <p className={styles.description}>
              {t('indiaPurchaseModal.descriptionLine2')}
            </p>
          </div>
        </div>
        <button
          type="button"
          className={styles.modalButton}
          onClick={onContinue}
          aria-label={t('indiaPurchaseModal.continueAria')}
          data-buttontype="performance_lab_india_purchase_continue"
        >
          {t('indiaPurchaseModal.continue')}
        </button>
      </div>
    </PerformanceLabModalBodyScrollLock>
  );
};
